import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import EllipsisHover from '@home/components/EllipsisHover';
import { getNewFeatureDisplayName } from '../../utils';

import type { INewFeatureItem } from '@home/types/urlCollection';

import './index.scss';

interface IFeatureCardProps extends IBaseProps {
  item: INewFeatureItem;
  onClick?: (item: INewFeatureItem) => void;
}

const FeatureCard: React.FC<IFeatureCardProps> = (props) => {
  const { style, className, item, onClick } = props;
  const { locale } = useIntl();
  const title = getNewFeatureDisplayName(locale, item);
  const isClickable = typeof onClick === 'function';
  const backgroundStyles = item?.display_image ? { backgroundImage: `url('${item.display_image}')` } : undefined;

  const handleClick = (): void => {
    onClick?.(item);
  };

  return (
    <div
      style={style}
      className={classnames('dbh-feature-card', className, {
        'dbh-feature-card--clickable': isClickable,
      })}
      onClick={handleClick}
    >
      <div className="dbh-feature-card__bg" style={backgroundStyles} />
      <div className="dbh-feature-card__mask" />
      <EllipsisHover className="dbh-feature-card__title" placement="top" text={title} />
    </div>
  );
};

export default FeatureCard;
